import { css } from '@emotion/css';
import { colors } from '@ajaibid/components';

export const stySvgIcon = ({ onClick }) => css`
  ${onClick &&
  `
    cursor: pointer;
    border-radius: 4px;

    &:hover {
      background-color: ${colors.AJAIB_BLUE_1};
    }
  `}
`;
